/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelmessageplaceholder2Inputs */

const en_channelmessageplaceholder2 = /** @type {(inputs: Channelmessageplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's new at Pulsify?`)
};

const de_channelmessageplaceholder2 = /** @type {(inputs: Channelmessageplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was gibt's Neues bei Pulsify?`)
};

/**
* | output |
* | --- |
* | "What's new at Pulsify?" |
*
* @param {Channelmessageplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelmessageplaceholder2 = /** @type {((inputs?: Channelmessageplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelmessageplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelmessageplaceholder2(inputs)
	return de_channelmessageplaceholder2(inputs)
});
export { channelmessageplaceholder2 as "channelMessagePlaceholder" }